'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = geocode;

var _isomorphicFetch = require('isomorphic-fetch');

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function geocode(address) {
  return (0, _isomorphicFetch2.default)('/api/geocode/' + address).then(function (response) {
    return response.json();
  }).then(function (_ref) {
    var results = _ref.results,
        status = _ref.status;

    if (status === 'OK') {
      var result = results[0].geometry.location;
      return result;
    }

    throw new Error(status);
  });
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/shared/redux/middlewares/geocoding/geocode.js
// module id = 1298
// module chunks = 0